import { render } from "./ApprovalsHome.vue?vue&type=template&id=033fb894&scoped=true"
import script from "./ApprovalsHome.vue?vue&type=script&lang=js"
export * from "./ApprovalsHome.vue?vue&type=script&lang=js"

import "./ApprovalsHome.vue?vue&type=style&index=0&id=033fb894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033fb894"]])

export default __exports__